import React, { useState, useEffect, useRef } from 'react';
import ItemsCarousel from 'react-items-carousel';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import { productsArrayPropTypes } from 'helpers/propTypes';
import ItemContainer from 'containers/ItemContainer';

const CarrouselProducts = ({ products, active }) => {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const productsRef = useRef([]);
  const activeItemIndexRef = useRef(0);
  const intervalRef = useRef(0);

  const responsiveCarrousel = () => {
    const w = window.innerWidth;
    if (w >= 768)  return 4;
    if (w >= 550)  return 3;
    if (w >= 200)  return 2;
    return 1;
  };

  const tick = () => {
    const total = productsRef.current.length;
    const visible = responsiveCarrousel();
    const next = (activeItemIndexRef.current + 1) % (total - visible + 1);
    setActiveItemIndex(next);
  };

  const stop = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = 0;
    }
  };
  const start = () => {
    if (!active && !intervalRef.current) {
      intervalRef.current = setInterval(tick, 2000);
    }
  };

  useEffect(() => {
    productsRef.current = products;
  }, [products]);

  useEffect(() => {
    start();
    return stop;
  }, []);

  useEffect(() => {
    activeItemIndexRef.current = activeItemIndex;
  }, [activeItemIndex]);

  useEffect(() => {
    if (active) stop();
    else if (active === '') start();
  }, [active]);

  const renderItem = item => (
    <div className="col-product-carrousel" key={item.id}>
      <ItemContainer item={item} />
      {item.stock_product_descriptions.length > 0 && window.innerWidth > 500 && (
        <div className="tooltip-item">
          <Tooltip title={item.description} arrow placement="top">
            <div className="tooltip-trigger">
              {/* un span transparente para capturar el hover */}
              <span />
            </div>
          </Tooltip>
          <ul className="description-list">
            {item.stock_product_descriptions.map(desc => (
              desc.stock > 0 && (
                <li key={desc.id}>
                  {desc.stock_descriptions.rgb
                    ? <span className="color" style={{ backgroundColor: desc.stock_descriptions.rgb }} />
                    : <span className="name">{desc.stock_descriptions.name}</span>}
                </li>
              )
            ))}
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <div
      className="carrousel-wrapper"
      onMouseEnter={stop}
      onMouseLeave={start}
    >
      <ItemsCarousel
        infiniteLoop
        gutter={30}
        activePosition="center"
        chevronWidth={60}
        numberOfCards={responsiveCarrousel()}
        outsideChevron
        activeItemIndex={activeItemIndex}
        requestToChangeActive={setActiveItemIndex}
        leftChevron={<div className="button-carrousel">{'<'}</div>}
        rightChevron={<div className="button-carrousel">{'>'}</div>}
      >
        {products.map(renderItem)}
      </ItemsCarousel>
    </div>
  );
};

CarrouselProducts.defaultProps = { active: null };
CarrouselProducts.propTypes = {
  products: productsArrayPropTypes.isRequired,
  active: PropTypes.string,
};

export default CarrouselProducts;
